import { Product } from '../../models/Product';
import { formatCurrency } from '../../services/FormatterService';
import './ProductPrice.less';

export type ProductPriceProps = {
    className?: string;
    product: Product;
};

const ProductPrice = ({
    className = '',
    product: { unitPrice, unitPriceOriginal, currency, locale }
}: ProductPriceProps) => (
    <div className={`bri-ProductPrice ${className}`}>
        {unitPriceOriginal && unitPriceOriginal !== unitPrice && (
            <span className={`bri-ProductPrice-unitPriceOriginal`}>
                {formatCurrency(unitPriceOriginal, currency, locale)}
            </span>
        )}
        <span className={`bri-ProductPrice-unitPrice`}>
            {formatCurrency(unitPrice, currency, locale)}
        </span>
    </div>
);

export default ProductPrice;
